<template>
  <div>
    <v-navigation-drawer
      class="elevation-5"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      left
    >
      <!--  -->
      <template>
        <v-container class="ml-6 mt-10">
          <v-layout row wrap justify-start align-start>
            <v-flex xs11 lg11 mb-10>
              <v-btn
                v-for="(item, i) in TextPath"
                :key="i"
                :color="$route.path !== item.path ? 'black' : 'grey'"
                text
                :to="item.path"
                ><v-icon left dark :disabled="$route.path !== item.path">
                  mdi-chevron-double-right
                </v-icon>
                {{ item.nameAPI }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
    </v-navigation-drawer>

    <v-app-bar app :clipped-left="$vuetify.breakpoint.lgAndUp" color="#077893">
      <v-app-bar-nav-icon dark @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="ml-0 pa-0 mt-0">
        <img
          class="d-sm-flex d-none"
          :src="require('@/assets/img/logoCMPWhite.png')"
          width="150"
        />
      </v-toolbar-title>
      <v-layout row wrap justify-center align-center mt-3>
        <v-flex xs9 lg9 class="pointer">
          <!-- {{ SelectBusiness }} -->
          <v-autocomplete
            style="color: #077893"
            v-if="$t('default') === 'th'"
            dark
            :label="$t('Profile.companyname')"
            outlined
            dense
            :loading="LoadingBusiness"
            item-text="BusinessNameTH"
            item-value="BusinessId"
            :items="ItemsBusiness"
            v-model="SelectBusiness"
            @change="Fn_SelectBusiness"
          >
          </v-autocomplete>
          <v-autocomplete
            v-else
            dark
            :label="$t('Profile.companyname')"
            outlined
            dense
            color="white"
            item-text="BusinessNameEng"
            item-value="BusinessId"
            :items="ItemsBusiness"
            v-model="SelectBusiness"
            @change="Fn_SelectBusiness"
          >
          </v-autocomplete>
          <!-- {{ SelectBusiness }} -->
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>
      <v-layout row wrap align-end justify-end class="d-md-flex d-none">
        <v-flex xs2 lg2 class="text-end">
          <img
            class="rounded-circle"
            :src="require('@/assets/img/thailand.png')"
            width="25"
            v-if="$t('default') === 'th'"
          />
          <img
            class="rounded-circle"
            :src="require('@/assets/img/united-kingdom.png')"
            width="25"
            v-if="$t('default') === 'en'"
          />
        </v-flex>
        <v-btn
          dense
          text
          dark
          class="font-weight-bold"
          @click="fn_changelanguage('th')"
          >TH</v-btn
        >
        <v-divider vertical color="white"></v-divider>
        <v-btn
          dense
          text
          dark
          class="font-weight-bold"
          @click="fn_changelanguage('en')"
          >EN</v-btn
        >
      </v-layout>
      <v-menu
        class="hidden-sm-and-down"
        :close-on-content-click="false"
        offset-y
        bottom
        open-on-hover
        transition="slide-y-transition"
        max-width="300"
      >
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            <v-icon class="mr-2" color="white">mdi-email-variant</v-icon>
            <span class="hidden-sm-and-down white--text">
              {{ Email }}
            </span>
            <v-icon color="white">mdi-menu-down</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-list dense>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon color="#077893" x-large>mdi-email-variant</v-icon>
              </v-list-item-avatar>

              <v-list-item-content class="text-left">
                <v-list-item-title class="pb-1" style="color: #077893">
                  {{ $t("Toolbar.email") }}
                </v-list-item-title>
                <v-list-item-subtitle style="color: #077893">
                  {{ Email }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="Fn_logout">
              <v-list-item-avatar> </v-list-item-avatar>
              <v-list-item-content class="text-left">
                <v-list-item-title class="pb-1" style="color: #077893">
                  {{ $t("Toolbar.logout") }}</v-list-item-title
                >
              </v-list-item-content>
              <v-list-item-avatar>
                <v-icon color="#077893">mdi-logout-variant</v-icon>
              </v-list-item-avatar>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data: () => ({
    drawer: null,
    TextPath: [
      {
        nameAPI: "รายการความยินยอม",
        path: "/consent-list-email",
      },
    ],
    loadingDownloadData: false,
    LoadingBusiness: false,
    drawer: null,
    SelectBusiness: "00000",
    BusinessId: "00000",
    Timestamps: "",
    RoleAccount: "",
    DataBusiness: [],
    ItemsBusiness: [],
    ItemsRole: [],
    ItemsNewRole: [],
    AllMenu: [],
  }),
  computed: {
    Email: {
      get() {
        return this.$cookies.get("EmailCMP") || "-";
      },
    },
  },
  async mounted() {
    // if (this.$cookies.get("BusinessIdEmail") === "00000") {
    //   this.SelectBusiness = this.$cookies.get("BusinessSelectEmail");
    //   this.$cookies.set("BusinessIdEmail", "00000");
    // } else {
    //   this.SelectBusiness = this.$cookies.get("BusinessIdEmail");
    // }
    // this.fn_getBusiness();
    if (this.$cookies.isKey("BusinessIdEmail") === true) {
      this.SelectBusiness = this.$cookies.get("BusinessIdEmail");
    } else {
      this.$cookies.set("BusinessIdEmail", "00000");
    }
    this.fn_getBusiness();
  },
  methods: {
    fn_changelanguage(language) {
      this.loadingDownloadData = true;
      if (language === "th") {
        setTimeout(() => (this.loadingDownloadData = false), 300);
        localStorage.setItem("lang", "th");
        this.$i18n.locale = "th";
      } else if (language === "en") {
        setTimeout(() => (this.loadingDownloadData = false), 300);
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
      }
    },
    Fn_SelectBusiness() {
      // if (this._StatusBusiness === true) {
      // this.$cookies.set("BusinessIdEmail", this.SelectBusiness);
      window.location.reload();
      // this.Fn_SyncBusiness()
      // }
    },
    async fn_getBusiness() {
      var payload = {
        // UserName: this.$cookies.get("OneUsername"),
        // AccountId: this.$cookies.get("OneAccountId"),
        AccessToken: this.$cookies.get("EmailAccessToken"),
        Email: this.Email,
      };
      // var Headers = {
      //   AccountId: this.$cookies.get("OneAccountId"),
      // };
      // var dataEncode = await authorization.encodeDataNew(payload);
      // var auth = await authorization.encodeDataNew(Headers);
      // var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "email/GetBusinessByEmail",
          // { Data: dataEncode },
          // { headers }
          payload
        )
        .then((response) => {
          this.loading = false;

          if (response.data.Status === "OK") {
            this.ItemsBusiness = response.data.Message;
            this.$store.dispatch("SET_ALLBUSINESS", this.ItemsBusiness);
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_logout() {
      this.$cookies.remove("EmailCMP");
      this.$cookies.remove("EmailAccessToken");
      this.$router.push("/");
    },
  },
  watch: {
    SelectBusiness: function (val) {
      this.$cookies.set("BusinessIdEmail", val);
      this.$store.dispatch("SET_BUSINESS", this.SelectBusiness);
      // this.$store.dispatch('SET_MENU')
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>

<style>
.theme--light.v-btn--active:hover::before,
.theme--light.v-btn--active::before {
  opacity: 0 !important;
}
.v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
  margin-right: 14px;
}

.v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
  margin-left: 4px;
}

.v-input__slot,
input#input-18,
.flex.white--text.fontSize.xs3.lg1,
.pointer,
input#input-27 {
  cursor: pointer !important;
}
</style>
